/* ECOSAC — interações do tema: pagamento (Pix e parcelas), banner, carrosséis, abas e zoom do produto. */

/* Parcelamento e Pix: mesmas regras do snippet eco-pay.liquid, para valores que mudam no navegador. */
window.EcoPay = (function () {
  'use strict';
  var cfg = window.ecoPaySettings || { installments: true, maxInstallments: 12, minInstallment: 500, pix: true, pixPct: 5 };

  function money(cents) {
    return 'R$ ' + (Math.round(cents) / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function calc(cents) {
    var n = cfg.maxInstallments;
    if (cfg.minInstallment > 0) n = Math.min(n, Math.floor(cents / cfg.minInstallment));
    n = Math.max(n, 1);
    return {
      n: n,
      parcel: Math.round(cents / n),
      pix: cents - Math.round(cents * cfg.pixPct / 100)
    };
  }
  function html(cents, scope) {
    if (!cfg.installments && !cfg.pix) return '';
    var c = calc(cents);
    var pixLabel = (scope === 'cart' || scope === 'drawer') ? 'Total no Pix' : 'No Pix';
    var suffix = cfg.suffix ? ' ' + cfg.suffix : '';
    var out = '<div class="eco-pay eco-pay--' + (scope || 'js') + '" data-eco-pay data-amount="' + cents + '">';
    if (cfg.pix) out += '<p class="eco-pay__row"><span class="eco-pay__label">' + pixLabel + ' <small>(' + cfg.pixPct + '% de desconto)</small></span><span class="eco-pay__value" data-eco-pay-pix-value>' + money(c.pix) + '</span></p>';
    if (cfg.installments && c.n > 1) out += '<p class="eco-pay__row" data-eco-pay-inst><span class="eco-pay__label">Parcelado</span><span class="eco-pay__value"><span data-eco-pay-inst-value>até ' + c.n + 'x de ' + money(c.parcel) + '</span>' + suffix + '</span></p>';
    return out + '</div>';
  }
  function update(el, cents) {
    if (!el) return;
    var c = calc(cents);
    el.dataset.amount = cents;
    var pix = el.querySelector('[data-eco-pay-pix-value]');
    if (pix) pix.textContent = money(c.pix);
    var inst = el.querySelector('[data-eco-pay-inst]');
    if (inst) {
      inst.hidden = c.n < 2;
      var v = inst.querySelector('[data-eco-pay-inst-value]');
      if (v) v.textContent = 'até ' + c.n + 'x de ' + money(c.parcel);
    }
  }
  return { html: html, update: update, calc: calc, money: money };
})();

(function () {
  'use strict';

  // Produto: atualiza Pix e parcelas ao trocar de variante.
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.price) window.EcoPay.update(document.querySelector('.eco-pay--pdp'), v.price);
  });

  /* Zoom da foto do produto: lupa ao passar o mouse e tela cheia ao clicar. */
  function initZoom() {
    var box = document.getElementById('pdp-main-image');
    var img = document.getElementById('pdp-img-main');
    if (!box || !img) return;
    box.classList.add('eco-zoomable');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (canHover) {
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        box.classList.add('is-zooming');
      });
      box.addEventListener('mouseleave', function () { box.classList.remove('is-zooming'); });
    }

    var lb = document.createElement('div');
    lb.className = 'eco-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Foto ampliada');
    lb.hidden = true;
    lb.innerHTML = '<button type="button" class="eco-lightbox__close" aria-label="Fechar">×</button><img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');

    function open() {
      var src = img.currentSrc || img.src;
      lbImg.src = src.replace(/([?&])width=\d+/, '$1width=1800');
      lbImg.alt = img.alt;
      lb.hidden = false;
      document.body.classList.add('eco-lock');
      lb.querySelector('button').focus();
    }
    function close() {
      lb.hidden = true;
      document.body.classList.remove('eco-lock');
    }
    box.addEventListener('click', open);
    lb.addEventListener('click', function (e) { if (e.target !== lbImg) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
  }
  document.addEventListener('DOMContentLoaded', initZoom);
})();

(function () {
  'use strict';

  function initHero(root) {
    var slides = root.querySelectorAll('[data-eco-slide]');
    var dots = root.querySelectorAll('[data-eco-dot]');
    if (slides.length < 2) return;
    var current = 0;
    var timer = null;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function restart() {
      if (root.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, (parseInt(root.dataset.interval, 10) || 6) * 1000);
    }

    var prev = root.querySelector('[data-eco-hero-prev]');
    var next = root.querySelector('[data-eco-hero-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); restart(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); restart(); }); });

    // No editor do tema, mostra o slide que está sendo editado.
    document.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target);
      if (idx > -1) { goTo(idx); clearInterval(timer); }
    });

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); restart(); }
      startX = null;
    });

    restart();
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-eco-track]');
    if (!track) return;
    function step() {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    }
    var prev = root.querySelector('[data-eco-prev]');
    var next = root.querySelector('[data-eco-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-eco-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active);
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-eco-hero]').forEach(initHero);
    scope.querySelectorAll('[data-eco-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-eco-tabs]').forEach(initTabs);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
